import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { CustomValidators } from '@biletix/core/common/validators/custom-validators';
import {CustomerAddress} from "@biletix/core/models/customer/customer-address.model";

@Component({
    selector: 'btx-invoice-information-form',
    templateUrl: './invoice-information-form.component.html',
    styleUrls: ['./invoice-information-form.component.scss'],
  standalone: false
})
export class InvoiceInformationFormComponent implements OnInit, OnDestroy {

    @Input("parentForm") parentForm: FormGroup | any;

    @Input("address") address: CustomerAddress | any;

    @Input("showTitle") showTitle: boolean = true;

    isCorporateAddress: boolean | any;//True ise kurumsal adress değilse bireysel adress

    constructor(private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.initializeInvoiceAddressForm();
    }

    initializeInvoiceAddressForm() {
        this.updateInvoiceAddress(this.address?.companyAddress ?? false);
    }

    //Kurumsal
    setCorporateAddress() {
        let companyTitle: string = '',//Firma Adı
            taxOffice: string = '',//Vergi Dairesi
            taxNo: string = '';//Vergi Numarası

        if (this.address) {
            companyTitle = this.address.companyTitle;
            taxOffice = this.address.taxOffice;
            taxNo = this.address.taxNo;
        }

        this.parentForm.setControl("invoiceInfo",
            this.fb.group({
                    companyTitle: [companyTitle, [Validators.required, Validators.maxLength(80)]],
                    taxOffice: [taxOffice, [Validators.required,Validators.maxLength(80)]],
                    taxNo: [taxNo, [Validators.required, Validators.pattern("^[0-9]*$"), 
                        Validators.maxLength(11), Validators.minLength(10), CustomValidators.identityNumber, CustomValidators.cannotContainSpace]],
                    companyAddress: [true]
                }
            )
        );

        this.isCorporateAddress = true;
    }

    //Bireysel
    setIndividualAddress() {
        this.parentForm.setControl("invoiceInfo",
            this.fb.group({
                    companyAddress: [false]
                }
            )
        );

        this.isCorporateAddress = false;
    }

    updateInvoiceAddress(isCorporateAddress: boolean) {
        if (isCorporateAddress != this.isCorporateAddress) {
            if (isCorporateAddress) {
                this.setCorporateAddress();
            } else {
                this.setIndividualAddress();
            }
        }
    }

    get invoiceAddressInfoFormGroup(): FormGroup {
        return this.parentForm.get("invoiceInfo") as FormGroup;
    }

    get invoiceAddressInfoFormGroupControls() {
        return this.invoiceAddressInfoFormGroup?.controls;
    }


    ngOnDestroy(): void {
        if (this.invoiceAddressInfoFormGroup) {
            this.parentForm.removeControl("invoiceInfo");
        }
    }
}
